/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import log from 'salvo-lite/log'
import zoom from 'jquery-zoom/jquery.zoom'

class Zoom {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)
        // $('.image-wrap [data-zoom]').zoom()
    }
}

export default Zoom



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Zoom.js